'use es6';

import { CART_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import ObjectDefinitionRecord from '../ObjectDefinitionRecord';
const Cart = ObjectDefinitionRecord({
  enableAsAssociatedType: true,
  hasAccess: (_isUngated, hasScope) => hasScope('carts-read'),
  objectTypeId: CART_TYPE_ID,
  referenceObjectType: 'CART_PROPERTIES'
});
export default Cart;